var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"wlx-coperation-enter-wrapper"},[_c('PartnerManager')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }